import { render } from "./open1.vue?vue&type=template&id=2b808604&scoped=true"
import script from "./open1.vue?vue&type=script&lang=js"
export * from "./open1.vue?vue&type=script&lang=js"

import "./open1.vue?vue&type=style&index=0&id=2b808604&lang=scss&scoped=true"

import exportComponent from "D:\\projectAll\\cnb_2\\oulimojuxiaozhunxitong\\BOSS_GC\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b808604"]])

export default __exports__